import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
import DashboardLayout from 'layout/Dashboard';

const Clientes = Loadable(lazy(() => import('pages/clientes')));
const ClienteDetalle = Loadable(lazy(() => import('pages/clientes/detalle')));
const Ventas = Loadable(lazy(() => import('pages/ventas')));
const VentaDetalle = Loadable(lazy(() => import('pages/ventas/detalle')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: '/',
      element: <Navigate to="/areas" replace />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <Navigate to="/areas" replace />
        },
        {
          path: 'clientes',
          children: [
            {
              path: '',
              element: <Clientes />
            },
            {
              path: ':id',
              element: <ClienteDetalle />
            }
          ]
        },
        {
          path: 'ventas',
          children: [
            {
              path: '',
              element: <Ventas />
            },
            {
              path: 'detalle/:id',
              element: <VentaDetalle />
            }
          ]
        }
      ]
    },
    
  ]
};

export default MainRoutes;
